<div
  class="box-border flex max-h-[min(500px,100%)] flex-col content-start items-start justify-start overflow-y-auto overflow-x-hidden bg-white p-[12px] shadow-sm md:shadow-lg"
>
  <div class="w-full flex-shrink flex-grow basis-[100%]">
    <ng-container *ngIf="(unseenNotifications$ | async)?.length">
      <div class="border-bottom mb-3 flex content-center items-center justify-start">
        {{ 'notifications.new' | translate }}
      </div>
      <ng-container *ngFor="let notification of unseenNotifications$ | async">
        <ng-container *ngTemplateOutlet="progress; context: { $implicit: notification }"></ng-container>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="(seenNotifications$ | async)?.length">
      <div class="border-bottom mb-3 flex content-center items-center justify-start">
        {{ 'notifications.seen' | translate }}
      </div>
      <ng-container *ngFor="let notification of seenNotifications$ | async">
        <mat-divider></mat-divider>
        <ng-container *ngTemplateOutlet="progress; context: { $implicit: notification }"></ng-container>
      </ng-container>
    </ng-container>
  </div>
</div>

<ng-template #progress let-item>
  <div
    [matTooltipDisabled]="!item.tooltip"
    [matTooltipShowDelay]="2000"
    [matTooltip]="item.tooltip"
    [ngClass]="{
      'border-[3px] border-hk_primary-600': item._seen === false,
    }"
    class="mb-2 border p-3"
    matTooltipTouchGestures="off"
  >
    <div class="flex content-center items-center justify-start gap-1">
      <i class="ph ph-download"></i>
      <h3 class="!m-0 min-w-0 px-2">
        <hk-text>{{ item.title }}</hk-text>
      </h3>
      <button
        (click)="button.callback()"
        *ngFor="let button of notification(item).actions || []"
        class="ml-auto shrink-0"
        data-testid="notificationsOverlay.button"
        hk-button-flat
      >
        <hk-icon-with-label [iconClass]="button.icon">{{ button.title }}</hk-icon-with-label>
      </button>
    </div>
    <mat-progress-bar *ngIf="item.progress !== undefined" [value]="item.progress" mode="determinate"></mat-progress-bar>
  </div>
</ng-template>
